<div #filterOutput class="checkbox-criteria">
  <kendo-svgicon *ngIf="svgIcon" class="checkbox-criteria-icon" [icon]="svgIcon"></kendo-svgicon>
  <input #myItems
         class="checkbox-criteria-check"
         kendoCheckBox
         type="checkbox"
         [checked]="checkValue"
         (change)="onChange()" />
  <kendo-label class="k-checkbox-label"
               [for]="myItems">
    {{ caption }}
  </kendo-label>
</div>
